export const BUDGETS = [
    { id: 'u50', label: 'Below ₹50k', test: (p: any) => p < 50000 },
    { id: '50-75', label: '₹50k – ₹75k', test: (p: any) => p >= 50000 && p < 75000 },
    { id: '75-100', label: '₹75k – ₹1L', test: (p: any) => p >= 75000 && p < 100000 },
    { id: '100-150', label: '₹1L – ₹1.5L', test: (p: any) => p >= 100000 && p < 150000 },
    { id: '150-200', label: '₹1.5L – ₹2L', test: (p: any) => p >= 150000 && p < 200000 },
    { id: '200+', label: 'Above ₹2L', test: (p: any) => p >= 200000 },
];

export const PACKAGES = [
    {
        id: 'mld',
        title: 'Maldives Bliss: 4 Nights in Overwater Villas',
        nights: 4,
        stops: [{ name: 'Male', nights: 1 }, { name: 'Maafushi', nights: 3 }],
        hotels: 2,
        activities: 4,
        price: 64200,
        image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        tag: "Editor's Pick",
        description: "Indulge in a luxurious escape to the Maldives. Experience stay in premium overwater villas, private deck access to crystal clear turquoise waters, snorkeling amidst vibrant coral reefs, and romantic sunset dinners on the beach.",
        highlights: [
            "Stay in an exquisite Overwater Villa with direct lagoon access",
            "Guided snorkeling tour to see sea turtles and colorful reefs",
            "Romantic sunset cruise with dolphin watching",
            "Private beachside candlelit dinner with premium dining options"
        ],
        inclusions: [
            "All speedboat transfers between airport and resorts",
            "Daily gourmet buffet breakfast and dinner (Half Board)",
            "Complimentary snorkeling gear rental",
            "All local taxes, green fees, and 24x7 concierge support"
        ],
        itinerary: [
            { day: 1, title: "Arrival & Speedboat Transfer to Male", description: "Welcome to the Maldives! Upon arrival at Velana International Airport, meet our representative and take a scenic speedboat transfer to your resort in Male. Check in and spend the evening relaxing by the beach or exploring local sights." },
            { day: 2, title: "Transfer to Maafushi & Island Walk", description: "After breakfast, transfer to the stunning island of Maafushi. Check into your deluxe beach front property. In the evening, enjoy a guided walking tour of the island, discovering local shops, cafes, and white sand beaches." },
            { day: 3, title: "Snorkeling Safari & Dolphin Cruise", description: "Embark on an exciting half-day excursion. Snorkel at two of the best reefs, enjoy a picnic lunch on a sandbank, and watch playful dolphins leap around your boat during the sunset return journey." },
            { day: 4, title: "Leisure Day & Water Sports", description: "Today is yours to spend at leisure. Choose to relax on the beach, book a spa treatment, or enjoy thrilling water sports like parasailing, jet skiing, or scuba diving." },
            { day: 5, title: "Departure", description: "Enjoy your final breakfast looking out at the Indian Ocean. Board your speedboat back to Velana International Airport for your flight home with beautiful memories." }
        ]
    },
    {
        id: 'san',
        title: 'Santorini & Athens: 6 Nights Aegean Romance',
        nights: 6,
        stops: [{ name: 'Athens', nights: 2 }, { name: 'Santorini', nights: 4 }],
        hotels: 2,
        activities: 5,
        price: 132500,
        image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Immerse yourself in history and romance on this Greek holiday. Explore the ancient ruins of Athens before flying to Santorini, where dramatic volcanic cliffs, whitewashed houses, and world-famous sunsets await.",
        highlights: [
            "Private guided tour of the Acropolis and Parthenon in Athens",
            "Traditional caldera view boutique hotel stay in Santorini",
            "Catamaran sunset cruise around the Santorini volcanic caldera",
            "Wine tasting session at a local cliffside vineyard"
        ],
        inclusions: [
            "Internal flights from Athens to Santorini",
            "Daily Greek breakfast at all hotels",
            "Guided tours and museum entrance tickets",
            "Private airport and port transfers"
        ],
        itinerary: [
            { day: 1, title: "Welcome to Athens", description: "Arrive in Athens and transfer to your hotel. Spend the afternoon wandering through the historic Plaka neighborhood, tasting local delicacies like souvlaki." },
            { day: 2, title: "Ancient Athens & Acropolis Tour", description: "Take a step back in time with a private guide visiting the Acropolis, the Ancient Agora, and the Temple of Olympian Zeus. Evening at leisure." },
            { day: 3, title: "Flight to Santorini", description: "Catch a short flight to the iconic island of Santorini. Check into your cliffside hotel in Oia or Fira, and watch the breathtaking sunset over the Aegean Sea." },
            { day: 4, title: "Caldera Catamaran Cruise", description: "Board a luxury catamaran for a cruise. Swim in the hot springs, snorkel near the Red and White beaches, and enjoy a delicious BBQ lunch onboard." },
            { day: 5, title: "Wine Tasting & Village Exploration", description: "Explore the traditional villages of Pyrgos and Megalochori. Later, visit a cliffside winery to taste Assyrtiko wine during sunset." },
            { day: 6, title: "Leisure Day in Santorini", description: "Spend your last full day shopping in Fira, hiking the scenic trail from Fira to Oia, or relaxing on the black sand beach of Perissa." },
            { day: 7, title: "Departure", description: "Transfer to Santorini airport for your flight back home or to Athens for your international connection." }
        ]
    },
    {
        id: 'bal',
        title: 'Bali Hideaway: 5 Nights Ubud & Seminyak',
        nights: 5,
        stops: [{ name: 'Ubud', nights: 2 }, { name: 'Seminyak', nights: 3 }],
        hotels: 2,
        activities: 3,
        price: 48900,
        image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Discover the twin souls of Bali: the lush, spiritual jungles of Ubud and the lively beachfronts of Seminyak. Perfect for couples seeking both culture and beachside relaxation.",
        highlights: [
            "Stay in a private pool villa nestled in Ubud's rainforest",
            "Visit the sacred Monkey Forest and Tegalalang Rice Terraces",
            "Watch the traditional Kecak Dance at Uluwatu Temple",
            "Sunset drinks and dinner at a trendy Seminyak beach club"
        ],
        inclusions: [
            "All inter-city transfers in private air-conditioned cars",
            "Daily breakfast plus a floating villa breakfast experience",
            "Professional English-speaking local guide for all sightseeing",
            "24/7 concierge assistance"
        ],
        itinerary: [
            { day: 1, title: "Arrival in Bali & Ubud Transfer", description: "Arrive at Ngurah Rai International Airport and transfer to your jungle villa in Ubud. Spend the night unwinding amidst the calming sounds of nature." },
            { day: 2, title: "Ubud Culture & Rice Terraces", description: "Visit the stunning Tegalalang Rice Terraces, try the famous Bali Swing, and walk through the Sacred Monkey Forest. End the day at Ubud Art Market." },
            { day: 3, title: "Transfer to Seminyak via Waterfalls", description: "Drive to Seminyak, stopping on the way to swim in Tegenungan Waterfall. Check into your beachside resort and explore Seminyak's dining scene." },
            { day: 4, title: "Uluwatu Sunset & Kecak Dance", description: "Relax on the beach in the morning. In the afternoon, visit the dramatic cliffside Uluwatu Temple to watch the fire dance during sunset." },
            { day: 5, title: "Beach Club Day & Balinese Spa", description: "Indulge in a 2-hour couples' spa massage treatment. Later, head to a popular beach club for sunset cocktails and dinner by the sea." },
            { day: 6, title: "Goodbye Bali", description: "Free time for last-minute shopping before transferring to the airport for your flight home." }
        ]
    },
    {
        id: 'swi',
        title: 'Swiss Alps Affair: 7 Nights Zurich, Lucerne & Interlaken',
        nights: 7,
        stops: [{ name: 'Zurich', nights: 2 }, { name: 'Lucerne', nights: 2 }, { name: 'Interlaken', nights: 3 }],
        hotels: 3,
        activities: 6,
        price: 168400,
        tag: 'Trending',
        image: "https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Journey through postcard-perfect Switzerland. Explore Zurich's historic old town, cruise the pristine waters of Lake Lucerne, and embark on mountain excursions in the heart of the Bernese Oberland.",
        highlights: [
            "Panoramic Swiss Travel Pass for seamless first-class train journeys",
            "Cogwheel train ride up to Mt. Pilatus near Lucerne",
            "Excursion to Jungfraujoch - The Top of Europe",
            "Scenic cruise on Lake Brienz or Lake Thun"
        ],
        inclusions: [
            "8-Day Swiss Travel Pass (2nd Class)",
            "Daily breakfast at highly rated alpine hotels",
            "Jungfraujoch excursion ticket",
            "Guided city walking tours in Zurich and Lucerne"
        ],
        itinerary: [
            { day: 1, title: "Arrive in Zurich", description: "Arrive in Zurich and check into your hotel. Spend the afternoon strolling along the Bahnhofstrasse or visiting the historic Grossmünster church." },
            { day: 2, title: "Zurich to Lucerne Scenic Train", description: "Take a scenic train ride to Lucerne. Walk across the iconic Chapel Bridge and explore the car-free Old Town." },
            { day: 3, title: "Mt. Pilatus Golden Roundtrip", description: "Take a lake boat, the world's steepest cogwheel railway, and aerial cableways to the summit of Mt. Pilatus for breathtaking Alpine views." },
            { day: 4, title: "Lucerne to Interlaken via Brunig Pass", description: "Board the Luzern-Interlaken Express train. Check into your hotel in Interlaken, nestled between two beautiful lakes." },
            { day: 5, title: "Jungfraujoch - Top of Europe", description: "Travel to the highest railway station in Europe. Experience the Sphinx Observatory, the Ice Palace, and walk on snow high in the Alps." },
            { day: 6, title: "Lake Brienz Cruise & Lauterbrunnen Valley", description: "Enjoy a morning cruise on Lake Brienz. In the afternoon, visit the Valley of 72 Waterfalls in Lauterbrunnen and hike to Staubbach Falls." },
            { day: 7, title: "Interlaken Leisure & Grindelwald First", description: "Take an optional excursion to Grindelwald First for the cliff walk, or spend the day paragliding over Interlaken and shopping." },
            { day: 8, title: "Return to Zurich & Departure", description: "Board a train back to Zurich Airport for your departure flight." }
        ]
    },
    {
        id: 'tha',
        title: 'Phuket & Krabi: 5 Nights Island Escape',
        nights: 5,
        stops: [{ name: 'Phuket', nights: 2 }, { name: 'Krabi', nights: 3 }],
        hotels: 2,
        activities: 4,
        price: 38600,
        image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Enjoy the perfect tropical holiday in southern Thailand. Soak up the vibrant beach life of Phuket before escaping to the limestone cliffs and quiet turquoise bays of Krabi.",
        highlights: [
            "Speedboat tour of the world-famous Phi Phi Islands",
            "Romantic sunset dinner overlooking Railay Beach",
            "Kayaking through mangrove forests in Ao Thalane",
            "Explore the lively markets and night life of Phuket"
        ],
        inclusions: [
            "All road and ferry transfers between Phuket and Krabi",
            "Daily buffet breakfast and Phi Phi tour lunch",
            "National Park entrance fees",
            "Shared or private local sightseeing guides"
        ],
        itinerary: [
            { day: 1, title: "Arrive in Phuket", description: "Arrive in Phuket and check in to your resort. Spend the evening visiting Patong Beach or watching a cultural show." },
            { day: 2, title: "Phi Phi Islands Tour by Speedboat", description: "Take a full-day speedboat tour. Snorkel in Maya Bay (featured in the movie 'The Beach'), swim in Pileh Lagoon, and see monkeys on Monkey Beach." },
            { day: 3, title: "Transfer to Krabi", description: "Take a scenic ferry ride across Phang Nga Bay to Krabi. Check into your hotel near Ao Nang and enjoy a quiet sunset walk on the beach." },
            { day: 4, title: "Four Islands Longtail Boat Tour", description: "Discover Phra Nang Cave, Tup Island, Chicken Island, and Poda Island. Enjoy swimming, sunbathing, and snorkeling in pristine waters." },
            { day: 5, title: "Railay Beach & Ao Thalane Kayaking", description: "Spend the morning kayaking in Ao Thalane's canyon. In the afternoon, head to Railay Beach (accessible only by boat) for rock climbing views and a beachside dinner." },
            { day: 6, title: "Departure", description: "Transfer to Krabi Airport for your flight back home." }
        ]
    },
    {
        id: 'dxb',
        title: 'Dubai Skyline: 4 Nights of Luxury',
        nights: 4,
        stops: [{ name: 'Dubai', nights: 4 }],
        hotels: 1,
        activities: 5,
        price: 52300,
        image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Witness the architectural marvels, ultra-modern shopping malls, and historical souks of Dubai. This package combines city luxury with the raw beauty of the Arabian desert.",
        highlights: [
            "Visit the 124th floor of Burj Khalifa - the world's tallest building",
            "Thrilling Desert Safari with dune bashing, camel rides, and BBQ dinner",
            "Guided Dubai Marina yacht cruise",
            "Excursion to the stunning Dubai Miracle Garden"
        ],
        inclusions: [
            "4 Nights stay at a 4-star city hotel in Dubai",
            "Burj Khalifa 'At The Top' entry tickets",
            "Daily breakfast plus desert BBQ dinner",
            "Private airport transfers and air-conditioned city tours"
        ],
        itinerary: [
            { day: 1, title: "Arrive in Dubai & Dhow Cruise", description: "Arrive in Dubai, meet our guide, and transfer to your hotel. In the evening, enjoy a traditional Arabic Dhow cruise along the Dubai Creek with buffet dinner." },
            { day: 2, title: "Dubai City Tour & Burj Khalifa", description: "Tour old and new Dubai (Jumeirah Mosque, Palm Jumeirah, Atlantis). Later, ascend the Burj Khalifa to the 124th floor observatory for panoramic views." },
            { day: 3, title: "Desert Safari & BBQ Night", description: "Spend the morning shopping. In the afternoon, head out for a desert safari featuring 4x4 dune bashing, sandboarding, camel rides, and a traditional belly-dancing BBQ show." },
            { day: 4, title: "Future Museum & Marina Yacht Cruise", description: "Visit the iconic Museum of the Future. In the evening, enjoy a luxury yacht cruise around Dubai Marina and the Palm." },
            { day: 5, title: "Departure", description: "Free time for shopping at Dubai Mall. Transfer to Dubai International Airport for your flight home." }
        ]
    }
];
